import * as React from 'react';
export const ArrowLeft = (props) => (React.createElement("svg", { width: "30", height: "23", viewBox: "0 0 30 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M29.5547 11.4994L1.44658 11.4994M1.44658 11.4994L10.6927 22.0399M1.44658 11.4994L10.6927 0.958838", stroke: "currentColor", strokeWidth: "1.5" })));
